import { NgOptimizedImage, NgTemplateOutlet } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { brandImages } from 'src/app/shared/model/brand-logo.model';
import { VariablesService } from 'src/app/shared/services';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-footer',
  imports: [NgOptimizedImage, RouterLink, NgTemplateOutlet],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  readonly vars = inject(VariablesService);
  readonly campaignUrl = computed(() => `${this.vars.domainData().fullUrl}${environment.campaign_url}?utm_source=Google_Organic&utm_medium=Organic_HomeCTA`);

  readonly brandImages = brandImages;
  readonly currentYear = new Date().getFullYear();
  readonly socialhandlers = [
    {
      "logopath": "assets/images/footer/facebook.svg",
      "clickUrl": "https://www.facebook.com/profile.php?id=61560557939347"
    },
    {
      "logopath": "assets/images/footer/x.svg",
      "clickUrl": "https://x.com/equalall_org"
    },
    // {
    //   "logopath": "assets/images/footer/linkedin.svg",
    //   "clickUrl" : ""
    // },
    // {
    //   "logopath": "assets/images/footer/youtube.svg",
    //   "clickUrl" : ""
    // },
    {
      "logopath": "assets/images/footer/instagram.svg",
      "clickUrl": "https://www.instagram.com/equalall_org/"
    },
    // {
    //   "logopath": "assets/images/footer/whatsapp.svg",
    //   "clickUrl" : ""
    // },
    {
      "logopath": "assets/images/footer/tiktok.svg",
      "clickUrl": "https://www.tiktok.com/@equalall_org"
    },
  ];

  linkhandler(link: string) {
    window.open(link, "_blank");
  }
}
